var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrcode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 10@0,5x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-6.6%",
    y: "-1.6%",
    width: "112.9%",
    height: "103.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "shadowSpreadOuter2",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.12 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter3",
    result: "shadowBlurOuter3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.14 0",
    type: "matrix",
    in: "shadowBlurOuter3",
    result: "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(-21.000000, -378.000000)",
    fill: "#FF4785",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dowbload-QR",
    transform: "translate(0.000000, 369.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,24.3328818 L26.6666667,24.3328818 L26.6666667,21.6661023 L24,21.6661023 L24,24.3328818 Z M34.6666667,19.0003386 L37.3333333,19.0003386 L37.3333333,13.6667795 L34.6666667,13.6667795 L34.6666667,19.0003386 Z M32,21.6661023 L37.3333333,21.6661023 L37.3333333,26.9996614 L34.6981587,26.9996614 L34.6981587,24.3024043 L32,24.3024043 L32,21.6661023 Z M39.9867937,21.6661023 L42.6788571,21.6661023 L42.6788571,24.2963088 L45.3079365,24.2963088 L45.3079365,21.6661023 L48,21.6661023 L48,24.2963088 L45.3079365,24.2963088 L45.3079365,26.9874704 L48,26.9874704 L48,32.3088385 L45.3079365,32.3088385 L45.3079365,35 L42.6788571,35 L42.6788571,32.3088385 L37.295746,32.3088385 L37.295746,35 L34.6666667,35 L34.6666667,29.6796478 L39.9867937,29.6796478 L39.9867937,26.9874704 L42.6788571,26.9874704 L42.6788571,24.2963088 L39.9867937,24.2963088 L39.9867937,21.6661023 Z M42.6666667,32.3332205 L45.3333333,32.3332205 L45.3333333,26.9996614 L42.6666667,26.9996614 L42.6666667,32.3332205 Z M40,19.0003386 L48,19.0003386 L48,11 L40,11 L40,19.0003386 Z M42.6666667,16.3335591 L45.3333333,16.3335591 L45.3333333,13.6667795 L42.6666667,13.6667795 L42.6666667,16.3335591 Z M24,19.0003386 L32,19.0003386 L32,11 L24,11 L24,19.0003386 Z M26.6666667,16.3335591 L29.3333333,16.3335591 L29.3333333,13.6667795 L26.6666667,13.6667795 L26.6666667,16.3335591 Z M24,35 L32,35 L32,26.9996614 L24,26.9996614 L24,35 Z M26.6666667,32.3332205 L29.3333333,32.3332205 L29.3333333,29.6664409 L26.6666667,29.6664409 L26.6666667,32.3332205 Z",
    id: "Fill-10"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrcode);
export default __webpack_public_path__ + "static/media/qrcode.d619a1d3f889d86d4f19e86d35204f47.svg";
export { ForwardRef as ReactComponent };